import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=c29a0e52&scoped=true"
import script from "@/views/Users/Guardian/Dashboard.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Guardian/Dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Guardian/dashboard.scss?vue&type=style&index=0&id=c29a0e52&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29a0e52",
  null
  
)

export default component.exports